import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

export default ImmutablePropTypes.mapContains({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  imageId: PropTypes.string
});
